import React from "react";
import { Switch, Route } from "react-router-dom";
import "./demo-view.css";
import { ServicesList, dimport, Page404 } from "../../components";
import { getDemoById } from "../../list";
import svgMotion from "../../assets/img/loading-motion.svg";

function DemoView() {
  let demoName = window.location.pathname.split("/")[2].toLowerCase();
  let demo = getDemoById(demoName);
  let demoComponent = demo !== undefined ? dimport(demo.id) : undefined;

  let classes = ["demo-container", demoName].join(" ");

  return (
    <>
      {demo ? (
        <div className={classes}>
          <ServicesList activeOne={demo.title} />
          <Switch>
            <Route
              path={`/service-detail/${demoName}/demo`}
              name={demoName}
              component={demoComponent}
            />
            <Route
              path={`/service-detail/${demoName}/fleets`}
              name={demoName}
              component={demoComponent}
            />
            <Route
              path={`/service-detail/${demoName}/intro`}
              name={demoName}
              component={demoComponent}
            />
          </Switch>
          <div className="svg-motion">
            <object type="image/svg+xml" data={svgMotion}>
              svgMotion
            </object>
          </div>
        </div>
      ) : (
        <Page404 />
      )}
    </>
  );
}

export default DemoView;
